<template>
  <div class="construction">
    <!-- 头部 -->
    <Header :logoURL="data.system.logo_image"></Header>
    <!-- 导航栏 -->
    <Nav :navList="data.navList"></Nav>
    <!-- 内容 -->
    <router-view></router-view>
    <!-- 底部 -->
    <floor></floor>
    <!--  -->
    <Time></Time>
    <!-- 左侧浮块 -->
    <div class="left-float" v-if="floatFlag">
      <div class="left-float-item" @click="gitMail">
        <span>我要参会</span>
      </div>
      <div class="left-float-item" @click="info(data.system.yq_url)">
        <span>邀请函</span>
      </div>
    </div>
    <!-- @mouseover="flag1 = true"
        @mouseleave="flag1 = false" -->
    <!-- 右侧付块 -->
    <div class="right-float" v-if="floatFlag">
      <div
        class="right-item"
        style="border-radius: 8px 0 0 0"
        @mouseover="flag1 = true"
      >
        <div class="img"><img src="../assets/qq.jpg" alt="" /></div>
        <span>QQ咨询</span>
        <div
          class="item-after-title-qq"
          v-if="flag1"
          @mouseleave="flag1 = false"
        >
          <div
            style="
              border-bottom: 2px solid #ebf025;
              margin: 5px 10px;
              text-align: center;
              padding: 5px 0;
            "
          >
            高招会（河南）
          </div>
          <div class="tan">
            在线客服1：<span>
              <a
                :href="`tencent://message/?uin=${data.system.qq1}&Site=qq&Menu=yes`"
                >QQ交谈</a
              >
            </span>
          </div>
          <div class="tan">
            在线客服2：<span>
              <a
                :href="`tencent://message/?uin=${data.system.qq2}&Site=qq&Menu=yes`"
                >QQ交谈</a
              >
            </span>
          </div>
          <div class="tan">
            在线客服3：<span>
              <a
                :href="`tencent://message/?uin=${data.system.qq3}&Site=qq&Menu=yes`"
                >QQ交谈</a
              >
            </span>
          </div>
          <div class="tan">
            在线客服4：<span>
              <a
                :href="`tencent://message/?uin=${data.system.qq4}&Site=qq&Menu=yes`"
                >QQ交谈</a
              >
            </span>
          </div>
        </div>
      </div>
      <div
        class="right-item"
        @mouseover="(flag2 = true), (flag1 = false)"
        @mouseleave="flag2 = false"
      >
        <div class="img"><img src="../assets/dianhua.jpg" alt="" /></div>
        <span>联系电话</span>
        <div class="item-after-title-tel" v-if="flag2">
          组委会：{{ data.system.tel }}
        </div>
      </div>
      <div
        class="right-item"
        @mouseover="(flag3 = true), (flag1 = false)"
        @mouseleave="flag3 = false"
      >
        <div class="img"><img src="../assets/erweima.jpg" alt="" /></div>
        <span>官方微信</span>
        <div class="item-after-title-er" v-if="flag3">
          <div class="img">
            <img :src="baseURL + data.system.qrcode_image" alt="" />
          </div>
          <span>微信二维码</span>
        </div>
      </div>
      <div class="right-item" @click="toTop" style="border-radius: 0 0 0 8px">
        <div class="img"><img src="../assets/zhiding.jpg" alt="" /></div>
        <span>返回顶部</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import Header from "../components/head.vue";
import Nav from "../components/nav";
import floor from "../components/floor";
import Time from "../components/Time";
import { useRouter, useRoute } from "vue-router";
import { watch, ref, reactive, onMounted } from "vue";
import { getHead_list, getIndex } from "../request/api";
import { baseURL } from "../request/baseURL";
const $router = useRouter();
const $route = useRoute();
const data = reactive({
  navList: [],
  system: {},
});
let flag1 = ref(false);
let flag2 = ref(false);
let flag3 = ref(false);
onMounted(() => {
  getHead_list().then((res) => {
    data.navList = res.data;
  });
  getIndex().then((res) => {
    data.system = res.data.system;
  });
});
// 回到顶部
const toTop = () => {
  document.documentElement.scrollTop = 0;
};
// 跳转到我要参会页面
const gitMail = () => {
  $router.push({ path: "/gitMail" });
};
// 监听路由变化
let floatFlag = ref(true);
const setFloatFlag = () => {
  let { fullPath } = $route;
  if (fullPath === "/gitMail" || fullPath === "/gitIdea") {
    floatFlag.value = false;
  } else {
    floatFlag.value = true;
  }
};
setFloatFlag();
watch($route, () => {
  setFloatFlag();
});
const info = (w_url) => {
  window.open(w_url);
};
</script>

<style lang="scss" scoped>
.left-float {
  width: 120px;
  height: 100px;
  position: fixed;
  left: 0;
  top: 400px;
  .left-float-item {
    height: 40px;
    font-size: 18px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    background-color: #da2d1f;
    margin-bottom: 8px;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
  }
}
.right-float {
  width: 80px;
  height: 500px;
  position: fixed;
  right: 0;
  top: 300px;
  .right-item {
    height: 100px;
    width: 100%;
    background-color: #da2d1f;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    cursor: pointer;
    color: #fff;
    .img {
      width: 70%;
      height: 60%;
    }
  }
  .item-after {
    position: absolute;
    left: -50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .item-after-title-qq {
    position: absolute;
    left: -155px;
    top: 0px;
    width: 150px;
    height: 150px;
    background-color: #da2d1f;
    border-radius: 8px;
    color: #fff;
  }
  .item-after-title-tel {
    position: absolute;
    left: -205px;
    top: 50px;
    width: 200px;
    height: 50px;
    background-color: #da2d1f;
    border-radius: 8px;
    color: #fff;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
  }
  .item-after-title-er {
    position: absolute;
    left: -135px;
    top: 0px;
    width: 130px;
    height: 140px;
    background-color: #da2d1f;
    border-radius: 8px;
    position: absolute;
    left: -135px;
    top: 0px;
    width: 130px;
    height: 140px;
    background-color: #da2d1f;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
    .img {
      width: 70%;
      height: 60%;
    }
  }
}
.construction {
  position: relative;
}
.tan {
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  margin: 5px 0;
  span {
    display: inline-block;
    background-color: #aee5fc;
    padding: 1px 5px;
    color: #000;
    border-radius: 3px;
  }
}
a {
  color: #000;
}
</style>
